import { render, staticRenderFns } from "./access_control_face_roster.vue?vue&type=template&id=c5678c88&scoped=true"
import script from "./access_control_face_roster.vue?vue&type=script&lang=js"
export * from "./access_control_face_roster.vue?vue&type=script&lang=js"
import style0 from "./access_control_face_roster.vue?vue&type=style&index=0&id=c5678c88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.34_babel-core@7.0.0-bridge.0_@babel+core@7.29._9691e8a1bbcd57691b862420a6e71e49/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5678c88",
  null
  
)

export default component.exports